(function () {
  'use strict';

  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function readI18n() {
    var fallback = {
      eyebrow: 'Guía de talla',
      title: 'Encuentra tu talla ideal',
      heightLabel: 'Altura',
      minusHeight: 'Bajar altura',
      plusHeight: 'Subir altura',
      recommendedLabel: 'Talla recomendada',
      correctSize: 'Talla recomendada:',
      noData: 'No hay datos suficientes para calcular la talla.',
      cm: 'cm',
      close: 'Cerrar',
      selectHint: 'Pulsa para seleccionar esta talla.'
    };
    var node = document.getElementById('labosch-v26-size-advisor-i18n');
    if (!node) return fallback;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      Object.keys(fallback).forEach(function (key) {
        if (!parsed[key] || /^translation missing/i.test(String(parsed[key]))) parsed[key] = fallback[key];
      });
      return parsed;
    } catch (error) {
      return fallback;
    }
  }

  var I18N = readI18n();

  var REMOTE_CACHE_KEY = 'lbx_size_guide_remote_cache';

  function setRemoteGuide(root, guide) {
    if (!root || !guide) return;
    root.__lbxRemoteSizeGuide = guide;
    try { window.__lbxRemoteSizeGuide = guide; } catch (error) {}
  }

  function getRemoteGuide(root) {
    return (root && root.__lbxRemoteSizeGuide) || (window && window.__lbxRemoteSizeGuide) || null;
  }

  function buildSizeGuideEndpoint() {
    var path = window.location.pathname || '';
    path = path.replace(/\/$/, '');
    return path + '?view=size-guide-json&_=' + Date.now();
  }

  function loadRemoteSizeGuide(root, callback) {
    var existing = getRemoteGuide(root);
    if (existing) {
      callback(existing);
      return;
    }

    if (!window.fetch) {
      callback(null);
      return;
    }

    fetch(buildSizeGuideEndpoint(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json,text/plain,*/*' }
    })
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var guide = findSizeGuideCandidate(text);
        if (guide) setRemoteGuide(root, guide);
        callback(guide || null);
      })
      .catch(function () {
        callback(null);
      });
  }



  function decodeHtmlEntities(value) {
    if (typeof value !== 'string') return value;
    return value
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function extractPossibleJsonSnippets(value) {
    var text = decodeHtmlEntities(String(value || ''));
    var snippets = [];

    function pushBalanced(openChar, closeChar) {
      for (var start = 0; start < text.length; start += 1) {
        if (text[start] !== openChar) continue;
        var depth = 0;
        var inString = false;
        var escaped = false;
        for (var i = start; i < text.length; i += 1) {
          var ch = text[i];
          if (inString) {
            if (escaped) {
              escaped = false;
            } else if (ch === '\\') {
              escaped = true;
            } else if (ch === '"') {
              inString = false;
            }
            continue;
          }
          if (ch === '"') {
            inString = true;
          } else if (ch === openChar) {
            depth += 1;
          } else if (ch === closeChar) {
            depth -= 1;
            if (depth === 0) {
              snippets.push(text.slice(start, i + 1));
              break;
            }
          }
        }
      }
    }

    pushBalanced('[', ']');
    pushBalanced('{', '}');

    return snippets;
  }

  function parseMaybeJson(value) {
    var parsed = decodeHtmlEntities(value);

    for (var attempt = 0; attempt < 3; attempt += 1) {
      if (typeof parsed !== 'string') break;
      var trimmed = decodeHtmlEntities(parsed).trim();
      if (!trimmed) return null;
      try {
        parsed = JSON.parse(trimmed);
      } catch (error) {
        var snippets = extractPossibleJsonSnippets(trimmed);
        for (var s = 0; s < snippets.length; s += 1) {
          try {
            var candidate = JSON.parse(snippets[s]);
            if (normalizeCustomSizeGuide(candidate).length) return candidate;
            parsed = candidate;
            break;
          } catch (innerError) {}
        }
        break;
      }
    }

    if (parsed && typeof parsed === 'object' && parsed.value) return parseMaybeJson(parsed.value);
    return parsed;
  }

  function findSizeGuideCandidate(value) {
    value = parseMaybeJson(value);
    var normalized = normalizeCustomSizeGuide(value);
    if (normalized && normalized.length) return value;

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i += 1) {
        var itemCandidate = findSizeGuideCandidate(value[i]);
        if (itemCandidate) return itemCandidate;
      }
    }

    if (value && typeof value === 'object') {
      if (value.value) {
        var valueCandidate = findSizeGuideCandidate(value.value);
        if (valueCandidate) return valueCandidate;
      }

      var keys = Object.keys(value);
      for (var k = 0; k < keys.length; k += 1) {
        var key = keys[k];
        if (/talla|tallaje|size|guide|guia|json|value|drop/i.test(key)) {
          var keyCandidate = findSizeGuideCandidate(value[key]);
          if (keyCandidate) return keyCandidate;
        }
      }

      for (var all = 0; all < keys.length; all += 1) {
        var anyCandidate = findSizeGuideCandidate(value[keys[all]]);
        if (anyCandidate) return anyCandidate;
      }
    }

    return null;
  }

  function readNodeText(node) {
    if (!node) return '';
    var tag = node.tagName && node.tagName.toLowerCase();
    if (tag === 'textarea') return node.value || node.textContent || '';
    return tag === 'template'
      ? (node.innerHTML || node.textContent || '')
      : (node.textContent || '');
  }

  function readEmbeddedSizeGuide(root) {
    var selectors = [
      '[data-lbx-real-size-guide]',
      '[data-lbx-real-size-guide-pack]',
      '[data-lbx-real-size-guide-scan]',
      '[data-lbx-real-size-guide-raw]',
      '[data-lbx-real-size-guide-text]'
    ];

    for (var s = 0; s < selectors.length; s += 1) {
      var nodes = Array.prototype.slice.call(root.querySelectorAll(selectors[s]));
      for (var n = 0; n < nodes.length; n += 1) {
        var candidate = findSizeGuideCandidate(readNodeText(nodes[n]));
        if (candidate) return candidate;
      }
    }

    var finalCandidate = findSizeGuideCandidate(root.innerHTML || root.textContent || '');
    if (finalCandidate) return finalCandidate;

    var remote = getRemoteGuide(root);
    if (remote) return remote;

    return null;
  }

  function normalizeCustomSizeGuide(rawGuide) {
    var normalized = [];
    rawGuide = parseMaybeJson(rawGuide);
    if (!rawGuide) return normalized;

    if (Array.isArray(rawGuide)) {
      rawGuide.forEach(function (item) {
        item = parseMaybeJson(item);
        if (!item) return;
        var size = item.talla || item.size || item.label || item.name;
        var min = item.min || item.min_cm || item.cm_min || item.desde || item.from;
        var hasOpenMax = Object.prototype.hasOwnProperty.call(item, 'max') && item.max === null;
        var max = hasOpenMax ? null : (item.max || item.max_cm || item.cm_max || item.hasta || item.to);
        min = parseFloat(min);
        max = hasOpenMax ? Infinity : parseFloat(max);
        if (size && !isNaN(min) && (hasOpenMax || !isNaN(max))) {
          normalized.push({ value: String(size), range: [min, max], openEnded: hasOpenMax });
        }
      });
    } else if (typeof rawGuide === 'object') {
      Object.keys(rawGuide).forEach(function (size) {
        var item = parseMaybeJson(rawGuide[size]);
        if (!item) return;
        var realSize = item.talla || item.size || item.label || item.name || size;
        var min = item.min || item.min_cm || item.cm_min || item.desde || item.from;
        var hasOpenMax = Object.prototype.hasOwnProperty.call(item, 'max') && item.max === null;
        var max = hasOpenMax ? null : (item.max || item.max_cm || item.cm_max || item.hasta || item.to);
        min = parseFloat(min);
        max = hasOpenMax ? Infinity : parseFloat(max);
        if (!isNaN(min) && (hasOpenMax || !isNaN(max))) {
          normalized.push({ value: String(realSize), range: [min, max], openEnded: hasOpenMax });
        }
      });
    }

    normalized.sort(function (a, b) {
      if (a.range[0] !== b.range[0]) return a.range[0] - b.range[0];
      return a.range[1] - b.range[1];
    });

    return normalized;
  }

  function parseRange(text) {
    var match = String(text || '').match(/(\d{2,3})\s*[–-]\s*(\d{2,3})/);
    if (!match) return null;
    return [Number(match[1]), Number(match[2])];
  }

  function formatRange(range) {
    if (!range) return '';
    return range[0] + (isFinite(range[1]) ? ('–' + range[1]) : '+') + ' ' + I18N.cm;
  }

  function sizeOrder(value) {
    var k = norm(value).replace(/ /g, '');
    var order = { xxs: 1, xs: 2, s: 3, m: 4, l: 5, xl: 6, xxl: 7 };
    if (order[k]) return order[k];
    var n = Number(k);
    return isNaN(n) ? 100 : n;
  }

  function collectSizeData(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.lbx-size-button'));
    var buttonMap = {};
    var orderedButtons = [];
    buttons.forEach(function (button) {
      var value = button.getAttribute('data-lbx-option-value') ||
        (button.querySelector('strong') && button.querySelector('strong').textContent) || '';
      value = String(value || '').trim();
      if (!value || buttonMap[norm(value)]) return;
      buttonMap[norm(value)] = button;
      orderedButtons.push(value);
    });

    var realGuide = normalizeCustomSizeGuide(readEmbeddedSizeGuide(root));
    var items = [];

    realGuide.forEach(function (guideItem) {
      var button = buttonMap[norm(guideItem.value)] || null;
      items.push({
        value: guideItem.value,
        range: guideItem.range,
        rawRange: guideItem.range.slice(),
        button: button,
        available: button ? (!button.disabled && !button.classList.contains('is-disabled')) : false
      });
    });

    // No fallback genérico: si no hay metacampo, no inventamos tallaje.
    return buildVisualItems(items);
  }

  function buildVisualItems(items) {
    items = items.slice().sort(function (a, b) {
      var ar = a.range ? a.range[0] : sizeOrder(a.value);
      var br = b.range ? b.range[0] : sizeOrder(b.value);
      return ar - br;
    });

    for (var i = 0; i < items.length; i += 1) {
      items[i].visualRange = items[i].range ? items[i].range.slice() : null;
    }

    for (var index = 0; index < items.length - 1; index += 1) {
      var left = items[index];
      var right = items[index + 1];
      if (!left.visualRange || !right.visualRange) continue;

      var boundary = left.visualRange[1] <= right.visualRange[0]
        ? right.visualRange[0]
        : ((left.visualRange[1] + right.visualRange[0]) / 2);

      var adjusted = boundary;
      if (left.available && !right.available) adjusted = boundary + 2;
      if (!left.available && right.available) adjusted = boundary - 2;

      adjusted = Math.max(left.visualRange[0] + 1, adjusted);
      adjusted = Math.min(right.visualRange[1] - 1, adjusted);

      left.visualRange[1] = adjusted;
      right.visualRange[0] = adjusted;
    }

    return items;
  }

  function rangeDistance(height, range) {
    if (!range) return 9999;
    if (height < range[0]) return range[0] - height;
    if (height > range[1]) return height - range[1];
    return 0;
  }

  function middleDistance(height, range) {
    if (!range) return 9999;
    return Math.abs(height - ((range[0] + range[1]) / 2));
  }

  function recommend(items, height) {
    var ranged = items.filter(function (item) { return item.range; });
    if (!ranged.length) return null;

    var inRange = ranged.filter(function (item) {
      return height >= item.range[0] && height <= item.range[1];
    });

    function sortBest(itemsToSort, useRangeDistance) {
      return itemsToSort.slice().sort(function (a, b) {
        var ad = useRangeDistance ? rangeDistance(height, a.range) : middleDistance(height, a.range);
        var bd = useRangeDistance ? rangeDistance(height, b.range) : middleDistance(height, b.range);
        var aStartsHere = Math.abs(height - a.range[0]) < 0.001;
        var bStartsHere = Math.abs(height - b.range[0]) < 0.001;
        if (aStartsHere !== bStartsHere) return aStartsHere ? -1 : 1;
        if (ad !== bd) return ad - bd;
        return a.range[0] - b.range[0];
      });
    }

    var exactAvailable = inRange.filter(function (item) { return item.available; });
    if (exactAvailable.length) return sortBest(exactAvailable, false)[0];

    if (inRange.length) {
      var primary = sortBest(inRange, false)[0];
      var nearAvailable = ranged
        .filter(function (item) {
          if (!item.available) return false;
          if (primary && norm(item.value) === norm(primary.value)) return false;
          var distance = rangeDistance(height, item.range);
          return distance > 0 && distance <= 2;
        })
        .sort(function (a, b) {
          var ad = rangeDistance(height, a.range);
          var bd = rangeDistance(height, b.range);
          if (ad !== bd) return ad - bd;
          return middleDistance(height, a.range) - middleDistance(height, b.range);
        })[0];

      return nearAvailable || primary;
    }

    var available = ranged.filter(function (item) { return item.available; });
    return sortBest(available.length ? available : ranged, true)[0];
  }

  function getStoredHeight() {
    try {
      var saved = Number(window.localStorage && localStorage.getItem('lbx_size_height_cm'));
      if (saved >= 120 && saved <= 230) return saved;
    } catch (e) {}
    return 175;
  }

  function setStoredHeight(value) {
    try { if (window.localStorage) localStorage.setItem('lbx_size_height_cm', String(value)); } catch (e) {}
  }

  function findOrCreateModal(root) {
    var modal = root.querySelector('[data-lbx-size-guide-modal]');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'lbx-size-guide-modal';
      modal.setAttribute('data-lbx-size-guide-modal', '');
      modal.hidden = true;
      root.appendChild(modal);
    }
    return modal;
  }

  function renderSizeList(items) {
    if (!items.length) return '';
    return '<div class="lbx-v27-size-list" data-lbx-v27-size-list>' + items.map(function (item, index) {
      return '<button type="button" class="lbx-v27-size-chip' + (item.available ? '' : ' is-unavailable') + '" data-lbx-v27-size-index="' + index + '"' + (item.available ? '' : ' disabled') + '>' +
        '<strong>' + escapeHtml(item.value) + '</strong>' +
        '<span>' + escapeHtml(formatRange(item.visualRange || item.range)) + '</span>' +
      '</button>';
    }).join('') + '</div>';
  }

  function renderAdvisor(root, modal) {
    var items = collectSizeData(root);
    if (!items.length) {
      modal.classList.add('lbx-v26-active');
      modal.innerHTML = '' +
        '<div class="lbx-v26-advisor-backdrop" data-lbx-v26-close></div>' +
        '<div class="lbx-size-guide-dialog lbx-v26-advisor-dialog" role="dialog" aria-modal="true" aria-labelledby="lbx-v26-size-title">' +
          '<button type="button" class="lbx-v26-advisor-close" data-lbx-v26-close aria-label="' + escapeHtml(I18N.close) + '">×</button>' +
          '<div class="lbx-v26-advisor-head">' +
            '<div class="lbx-v26-advisor-eyebrow">' + escapeHtml(I18N.eyebrow) + '</div>' +
            '<h2 class="lbx-v26-advisor-title" id="lbx-v26-size-title">' + escapeHtml(I18N.title) + '</h2>' +
          '</div>' +
          '<div class="lbx-v27-recommendation-card">' +
            '<div class="lbx-v27-result-copy">' +
              '<span class="lbx-v27-result-label">Guía no configurada</span>' +
              '<div class="lbx-v26-result">No se ha encontrado una guía de tallas JSON válida. Revisa que el producto tenga labosch.guia_tallas_json guardado.</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      return;
    }
    var min = 150;
    var max = 205;
    var ranges = items.map(function (item) { return item.visualRange || item.range; }).filter(Boolean);
    if (ranges.length) {
      min = Math.max(120, Math.min.apply(null, ranges.map(function (r) { return r[0]; })) - 8);
      max = Math.min(230, Math.max.apply(null, ranges.map(function (r) { return r[1]; })) + 8);
    }
    var height = getStoredHeight();
    if (height < min) height = min;
    if (height > max) height = max;

    modal.classList.add('lbx-v26-active');
    modal.innerHTML = '' +
      '<div class="lbx-v26-advisor-backdrop" data-lbx-v26-close></div>' +
      '<div class="lbx-size-guide-dialog lbx-v26-advisor-dialog" role="dialog" aria-modal="true" aria-labelledby="lbx-v26-size-title">' +
        '<button type="button" class="lbx-v26-advisor-close" data-lbx-v26-close aria-label="' + escapeHtml(I18N.close) + '">×</button>' +
        '<div class="lbx-v26-advisor-head">' +
          '<div class="lbx-v26-advisor-eyebrow">' + escapeHtml(I18N.eyebrow) + '</div>' +
          '<h2 class="lbx-v26-advisor-title" id="lbx-v26-size-title">' + escapeHtml(I18N.title) + '</h2>' +
        '</div>' +
        '<div class="lbx-v27-advisor-body">' +
          '<div class="lbx-v27-height-card">' +
            '<div class="lbx-v26-stepper">' +
              '<button type="button" class="lbx-v26-stepper-button" data-lbx-v26-minus aria-label="' + escapeHtml(I18N.minusHeight) + '">−</button>' +
              '<div class="lbx-v26-stepper-center">' +
                '<span class="lbx-v26-stepper-label">' + escapeHtml(I18N.heightLabel) + '</span>' +
                '<span class="lbx-v26-stepper-value"><strong data-lbx-v26-height-text>' + height + '</strong><span>' + escapeHtml(I18N.cm) + '</span></span>' +
              '</div>' +
              '<button type="button" class="lbx-v26-stepper-button" data-lbx-v26-plus aria-label="' + escapeHtml(I18N.plusHeight) + '">+</button>' +
            '</div>' +
            '<div class="lbx-v26-range-wrap">' +
              '<input class="lbx-v26-range" type="range" min="' + min + '" max="' + max + '" step="1" value="' + height + '" data-lbx-v26-range aria-label="' + escapeHtml(I18N.heightLabel) + '">' +
              '<div class="lbx-v27-range-meta"><span>' + min + ' ' + escapeHtml(I18N.cm) + '</span><span>' + max + ' ' + escapeHtml(I18N.cm) + '</span></div>' +
            '</div>' +
          '</div>' +
          '<div class="lbx-v27-recommendation-card" data-lbx-v26-result-card>' +
            '<div class="lbx-v26-size-bubble" data-lbx-v26-bubble>–</div>' +
            '<div class="lbx-v27-result-copy">' +
              '<span class="lbx-v27-result-label">' + escapeHtml(I18N.recommendedLabel) + '</span>' +
              '<div class="lbx-v26-result" data-lbx-v26-result role="button" tabindex="0"></div>' +
              '<div class="lbx-v26-assistive">' + escapeHtml(I18N.selectHint) + '</div>' +
            '</div>' +
          '</div>' +
          renderSizeList(items) +
        '</div>' +
      '</div>';

    var range = modal.querySelector('[data-lbx-v26-range]');
    var minus = modal.querySelector('[data-lbx-v26-minus]');
    var plus = modal.querySelector('[data-lbx-v26-plus]');
    var result = modal.querySelector('[data-lbx-v26-result]');
    var resultCard = modal.querySelector('[data-lbx-v26-result-card]');
    var sizeChips = Array.prototype.slice.call(modal.querySelectorAll('[data-lbx-v27-size-index]'));

    function setRangeProgress(value) {
      if (!range) return;
      var pct = ((Number(value) - min) / (max - min)) * 100;
      if (!isFinite(pct)) pct = 0;
      range.style.setProperty('--lbx-progress', Math.max(0, Math.min(100, pct)) + '%');
    }

    function update(nextHeight) {
      var value = Number(nextHeight);
      if (!value || value < min) value = min;
      if (value > max) value = max;
      value = Math.round(value);
      setStoredHeight(value);
      range.value = String(value);
      setRangeProgress(value);
      var label = modal.querySelector('[data-lbx-v26-height-text]');
      if (label) label.textContent = String(value);
      var rec = recommend(items, value);
      var bubble = modal.querySelector('[data-lbx-v26-bubble]');
      sizeChips.forEach(function (chip) { chip.classList.remove('is-recommended'); });
      if (!rec) {
        if (bubble) bubble.textContent = '–';
        result.textContent = I18N.noData;
        result.__lbxV26Button = null;
        return;
      }
      if (bubble) bubble.textContent = rec.value;
      result.innerHTML = escapeHtml(I18N.correctSize) + ' <strong>' + escapeHtml(rec.value) + '</strong>';
      result.__lbxV26Button = rec.button || null;
      var recIndex = items.indexOf(rec);
      if (recIndex > -1 && sizeChips[recIndex]) sizeChips[recIndex].classList.add('is-recommended');
    }

    range.addEventListener('input', function () { update(range.value); });
    minus.addEventListener('click', function () { update(Number(range.value) - 1); });
    plus.addEventListener('click', function () { update(Number(range.value) + 1); });

    function selectRecommended() {
      if (result.__lbxV26Button && !result.__lbxV26Button.disabled) {
        result.__lbxV26Button.click();
        closeAdvisor(modal);
      }
    }

    result.addEventListener('click', selectRecommended);
    if (resultCard) resultCard.addEventListener('click', selectRecommended);
    result.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectRecommended();
      }
    });

    sizeChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var index = Number(chip.getAttribute('data-lbx-v27-size-index'));
        var item = items[index];
        if (!item || !item.available || !item.button) return;
        item.button.click();
        closeAdvisor(modal);
      });
    });

    update(height);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  function modalHasConfiguredGuide(modal) {
    if (!modal || modal.hidden) return false;
    if (modal.querySelector('[data-lbx-v27-size-list]')) return true;
    if (modal.querySelector('[data-lbx-v26-range]')) return true;
    var text = (modal.textContent || '').toLowerCase();
    return text.indexOf('guía no configurada') === -1 &&
      text.indexOf('guia no configurada') === -1 &&
      text.indexOf('no se ha encontrado') === -1 &&
      text.indexOf('no hay datos') === -1 &&
      text.trim().length > 40;
  }


  function hideNonV26Modals(activeModal) {
    Array.prototype.slice.call(document.querySelectorAll('.lbx-size-guide-modal:not(.lbx-v26-active)')).forEach(function (modal) {
      if (modal && modal !== activeModal) {
        modal.hidden = true;
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function openAdvisor(trigger) {
    var root = trigger.closest('[id^="lbx-product-"]');
    if (!root) return;
    var modal = findOrCreateModal(root);

    if (modalHasConfiguredGuide(modal)) {
      return;
    }

    function show() {
      if (modalHasConfiguredGuide(modal)) {
        return;
      }

      renderAdvisor(root, modal);
      modal.hidden = false;
      modal.style.display = 'flex';
      modal.setAttribute('aria-hidden', 'false');
      hideNonV26Modals(modal);
      document.documentElement.classList.add('lbx-v26-modal-open');
      setTimeout(function () {
        var range = modal.querySelector('[data-lbx-v26-range]');
        if (range) range.focus({ preventScroll: true });
      }, 50);
    }

    var immediateGuide = normalizeCustomSizeGuide(readEmbeddedSizeGuide(root));
    if (immediateGuide && immediateGuide.length) {
      show();
      return;
    }

    loadRemoteSizeGuide(root, function (guide) {
      if (modalHasConfiguredGuide(modal)) {
        return;
      }

      if (guide && normalizeCustomSizeGuide(guide).length) {
        show();
        return;
      }

      // No sobrescribimos un modal correcto que haya abierto otro script.
      setTimeout(function () {
        if (!modalHasConfiguredGuide(modal)) {
          show();
        }
      }, 80);
    });
  }

  function closeAdvisor(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lbx-v26-modal-open');
  }


  window.__lbxV26SizeAdvisorClickBound = true;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-lbx-size-guide-open], .lbx-size-guide-link, .lbx-v29-size-guide-link');
    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      opener.__lbxSizeAdvisorHandled = true;
      openAdvisor(opener);
      return;
    }

    var closer = event.target.closest && event.target.closest('[data-lbx-v26-close]');
    if (closer) {
      event.preventDefault();
      closeAdvisor(closer.closest('[data-lbx-size-guide-modal]'));
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('.lbx-size-guide-modal.lbx-v26-active:not([hidden])');
    if (modal) closeAdvisor(modal);
  });
})();
